/** Workflows phase 3 (M26): oras, SLA, rating at attributes. Isinasama sa `engage.workflows`. */
export const workflowsP3 = {
  triggers: {
    visitor_unresponsive: "Hindi sumasagot ang bisita",
    staff_unresponsive: "Hindi sumasagot ang staff",
    note_added: "Nagdagdag ng tala ang staff",
    before_sla_breach: "Bago malampasan ang SLA",
    sla_breached: "Nalampasan ang SLA",
    visitor_visits_page: "Bumisita ang bisita sa isang pahina",
    visitor_event: "Event ng bisita mula sa inyong site",
    conversation_rated: "Na-rate ang usapan",
  },
  triggerHints: {
    visitor_unresponsive: "Kamustahin sila, saka isara na may kahilingang mag-rate.",
    staff_unresponsive: "I-reassign o i-escalate kapag walang sumasagot.",
    note_added: "Mga aksyon sa background mula sa internal notes.",
    before_sla_breach: "Balaan ang team bago malampasan ang target.",
    sla_breached: "I-escalate kapag nalampasan ang target.",
    visitor_visits_page: "Proactive na mensahe pagkatapos ng ilang sandali sa katugmang URL.",
    visitor_event: "Tumugon sa mga event na ipinapadala ng inyong site gamit ang Sagot('track').",
    conversation_rated: "Mag-follow up sa mababang rating o magpasalamat sa masayang bisita.",
  },
  steps: {
    wait: "Maghintay",
    apply_sla: "Ilapat ang SLA policy",
    set_priority: "Itakda ang priority",
    ask_rating: "Humingi ng rating",
    email_visitor: "Mag-email sa bisita",
    set_attribute: "Itakda ang attribute",
  },
  summaries: {
    rating: "{{scale}} · {{question}}",
    wait_minutes_one: "Maghintay ng {{count}} minuto",
    wait_minutes_other: "Maghintay ng {{count}} minuto",
    wait_hours_one: "Maghintay ng {{count}} oras",
    wait_hours_other: "Maghintay ng {{count}} oras",
    wait_days_one: "Maghintay ng {{count}} araw",
    wait_days_other: "Maghintay ng {{count}} araw",
    waitUntilOffice: "{{wait}}, hanggang magbukas ang opisina",
    apply_sla: "Policy: {{policy}}",
    set_priority: "Priority → {{priority}}",
    email_visitor: "Email: {{subject}}",
    set_attribute: "{{target}} = {{value}}",
  },
  exits: {
    interrupted: "Naputol",
    rated: "Na-rate",
  },
  fields: {
    waitFor: "Maghintay ng",
    waitValue: "Dami ng paghihintay",
    waitUnit: "Yunit ng paghihintay",
    waitUnits: { minutes: "minuto", hours: "oras", days: "araw" },
    waitCap: "Hanggang {{value}} {{unit}} ang pinapayagan ng inyong plan.",
    waitTooLong: "Mas mahaba ito kaysa sa pinapayagan ng inyong plan ({{value}} {{unit}}). Paikliin bago i-publish.",
    untilOffice: "Pagkatapos, hintayin ang oras ng opisina",
    untilOfficeHint: "Kung matapos ang paghihintay habang sarado ang opisina, magpapatuloy ang run kapag nagbukas ito.",
    interruptOn: "Itigil ang paghihintay kapag",
    interrupts: { visitor_reply: "sumagot ang bisita", staff_reply: "sumagot ang miyembro ng team", closed: "naisara ang usapan" },
    interruptHint: "Kung wala sa mga ito ang napili, palaging hihintayin ang buong oras.",
    interruptedGoTo: "Kung maputol, pumunta sa",
    interruptedHint: "Kung walang piniling path, tatapusin ng naputol na paghihintay ang run.",
    slaGateTitle: "Nasa Institution plan ang mga SLA policy",
    slaGateBody: "Sinusubaybayan ng mga SLA policy ang target sa unang tugon at sa paglutas, at binabalaan ang inyong team bago ito malampasan.",
    slaUpgrade: "Tingnan ang mga plan sa Billing",
    slaPolicy: "SLA policy",
    slaPolicyHint: "Magsisimula ang mga orasan nito kapag tumakbo ang step na ito. Pamahalaan ang mga policy sa Settings → SLA policies.",
    slaLoadFailed: "Hindi namin ma-load ang inyong mga SLA policy.",
    slaNone: "Wala pang SLA policy.",
    slaOpenSettings: "Buksan ang SLA policies",
    priority: "Priority",
    priorityHint: "Makikita ito ng staff sa Inbox, kung saan maaaring i-sort at i-filter ang mga usapan ayon dito.",
    ratingQuestion: "Tanong",
    ratingQuestionHint: "Ipinapakita sa itaas ng mga bituin o thumbs.",
    ratingScale: "Scale ng rating",
    ratingScales: { stars: "5 bituin", thumbs: "Thumbs up / down" },
    askComment: "Humingi ng komento",
    askCommentHint: "Pagkatapos mag-rate, maaaring magdagdag ang bisita ng hanggang {{max}} character. Maaari rin nila itong laktawan.",
    emailConsent: "Ipapadala lamang kapag alam namin ang email ng bisita at pumayag silang kontakin. Kung hindi, lalaktawan ang step. Isang beses lang ito ipapadala bawat run.",
    emailSubject: "Paksa",
    emailBody: "Mensahe",
    emailBodyHint: "Gumagana ang bold, italic at mga link.",
    attributeObject: "Itakda sa",
    attributeKey: "Attribute",
    attributeValue: "Halaga",
    attributeValueHint: "Nakatakdang halaga, o variable mula sa listahan sa ibaba.",
    noAttributes: "Wala pang naka-define na attribute para sa object na ito.",
    openAttributes: "Buksan ang Attributes",
  },
  incomplete: {
    policy: "Pumili ng SLA policy",
    emailSubject: "Isulat ang paksa",
    emailBody: "Isulat ang mensahe",
    attribute: "Piliin ang attribute",
    attributeValue: "Magtakda ng halaga",
  },
  customSchedule: {
    title: "Lingguhang iskedyul",
    hint: "Ginagamit ang time zone ng inyong workspace. Sarado ang araw na walang oras.",
    zone: "Time zone ng workspace: {{zone}}",
    days: { mon: "Lunes", tue: "Martes", wed: "Miyerkules", thu: "Huwebes", fri: "Biyernes", sat: "Sabado", sun: "Linggo" },
    closed: "Sarado",
    rangeLabel: "{{day}} {{part}} (range {{n}})",
    from: "bubukas",
    to: "magsasara",
    removeRange: "Alisin ang range {{n}} ng {{day}}",
    addRange: "Magdagdag ng oras",
    addRangeFor: "Magdagdag ng oras sa {{day}}",
    problems: {
      format: "Gumamit ng oras tulad ng 08:00.",
      order: "Dapat mas huli ang oras ng pagsasara kaysa sa pagbubukas.",
      overlap: "Nag-o-overlap ang range na ito sa naunang range.",
    },
  },
  options: {
    title: "Mga opsyon ng trigger",
    minutes: "Minuto na walang sagot",
    minutesRange: "Mula 1 hanggang {{max}} minuto (7 araw).",
    minutesHint: {
      visitor_unresponsive: "Magsisimula kapag hindi pa sumasagot ang bisita sa loob ng ganitong katagal pagkatapos ng huling mensahe ng assistant o ng inyong team.",
      staff_unresponsive: "Magsisimula kapag walang sumagot sa inyong team sa loob ng ganitong katagal pagkatapos magsulat ng bisita habang may nakatalagang tao.",
    },
    urlRules: "Mga pahina",
    urlRulesHint: "Magsisimula ang workflow sa mga pahinang tumutugma sa alinmang rule. Kung walang rule, para ito sa lahat ng pahina.",
    ruleOperator: "Operator ng rule {{n}}",
    ruleValue: "URL ng rule {{n}}",
    urlPlaceholder: "hal. /admissions",
    removeRule: "Alisin ang rule {{n}}",
    addRule: "Magdagdag ng rule sa pahina",
    operators: { is: "Ang URL ay", contains: "Naglalaman ang URL ng", starts_with: "Nagsisimula ang URL sa" },
    secondsOnPage: "Segundo sa pahina",
    secondsOnPageHint: "Gaano katagal mananatili ang bisita bago lumabas ang mensahe.",
    frequency: "Ipakita hanggang",
    frequencies: {
      until_engaged: "makipag-ugnayan ang bisita (mag-tap ng button)",
      until_interacted: "mag-interact ang bisita sa anumang paraan",
      once: "Isang beses lang makita",
      every_session: "Bawat session",
    },
    eventHint: "Magdagdag ng kondisyong “Pangalan ng event” sa ibaba para piliin kung aling event ang magsisimula ng workflow na ito. Nagpapadala ang inyong site ng events gamit ang Sagot('track', 'pangalan_ng_event').",
  },
  conditionFields: {
    conversation_priority: "Priority",
    conversation_rating: "Rating (1–5)",
    event_name: "Pangalan ng event",
    page_url: "URL ng pahina",
    sla_breached: "Nalampasan ang SLA",
  },
  conditionGroups: {
    conversation: "Usapan",
    message: "Mensahe",
    lead: "Lead",
    booking: "Booking",
    visitor: "Bisita",
    time: "Oras",
    event: "Event",
    intent: "Intent",
    page: "Pahina",
    sla: "SLA",
  },
  attributeGroups: {
    visitor: "Mga attribute ng bisita",
    conversation: "Mga attribute ng usapan",
    lead: "Mga attribute ng lead",
  },
} as const;
